<template>
  <section id="homeBeforeAfter" class="container my-5 p-3 p-lg-5" v-if="beforeAfter">
    <div v-if="beforeAfter.length">
      <div class="d-flex align-items-center gap-15">
        <!-- <span>
          <svg
            width="39"
            height="33"
            viewBox="0 0 39 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.6086 5.74549C33.5044 8.01302 38.1358 10.5073 38.8874 13.875C39.6391 17.2343 36.5031 21.4586 33.561 24.9103C30.619 28.362 27.8709 31.0326 24.6621 32.1328C21.4533 33.2329 17.7838 32.7626 14.5507 31.3937C11.3177 30.0164 8.52113 27.7489 6.18526 24.6667C3.84939 21.5762 1.97423 17.671 2.04697 13.5727C2.11163 9.47431 4.11611 5.18281 7.32491 2.78931C10.5337 0.395808 14.9549 -0.0996878 18.7456 0.672951C22.5364 1.44559 25.7047 3.47796 29.6086 5.74549Z"
              fill="#EEEEEE"
            />
            <path
              d="M15.4997 22.8552C14.983 22.8552 14.4663 22.8164 13.9755 22.726C11.2372 22.3256 8.74426 20.7498 7.16842 18.4118C6.07051 16.7585 5.48926 14.8339 5.48926 12.8448C5.48926 7.32935 9.98426 2.83435 15.4997 2.83435C21.0151 2.83435 25.5101 7.32935 25.5101 12.8448C25.5101 14.8339 24.9288 16.7585 23.8309 18.4118C22.2422 20.7627 19.7493 22.3256 16.9851 22.7389C16.533 22.8164 16.0163 22.8552 15.4997 22.8552ZM15.4997 4.77185C11.0434 4.77185 7.42676 8.38852 7.42676 12.8448C7.42676 14.4594 7.89176 16.0094 8.77009 17.3269C10.0488 19.2127 12.0509 20.4785 14.2726 20.8014C15.0993 20.9435 15.913 20.9435 16.6751 20.8014C18.9355 20.4785 20.9376 19.1998 22.2163 17.3139C23.0947 15.9964 23.5597 14.4464 23.5597 12.8318C23.5726 8.3885 19.9559 4.77185 15.4997 4.77185Z"
              fill="#eb6fa7"
            />
            <path
              d="M8.35646 30.3984C8.17563 30.3984 8.00771 30.3726 7.82688 30.3338C6.98729 30.1401 6.34146 29.4942 6.14771 28.6546L5.69563 26.7559C5.66979 26.6396 5.57938 26.5492 5.45021 26.5105L3.31896 26.0067C2.51813 25.813 1.88521 25.2188 1.66563 24.4309C1.44604 23.643 1.66563 22.7905 2.24688 22.2092L7.28438 17.1717C7.49104 16.9651 7.77521 16.8617 8.05938 16.8876C8.34354 16.9134 8.60188 17.0684 8.76979 17.3138C10.0485 19.1996 12.0506 20.4784 14.2852 20.8013C15.1119 20.9434 15.9256 20.9434 16.6877 20.8013C18.9481 20.4784 20.9502 19.1996 22.229 17.3138C22.384 17.0684 22.6552 16.9134 22.9394 16.8876C23.2235 16.8617 23.5077 16.9651 23.7144 17.1717L28.7519 22.2092C29.3331 22.7905 29.5527 23.643 29.3331 24.4309C29.1135 25.2188 28.4677 25.8259 27.6798 26.0067L25.5485 26.5105C25.4323 26.5363 25.3419 26.6267 25.3031 26.7559L24.851 28.6546C24.6573 29.4942 24.0115 30.1401 23.1719 30.3338C22.3323 30.5405 21.4669 30.2434 20.9244 29.5846L15.4994 23.3459L10.0744 29.5976C9.63521 30.1142 9.01521 30.3984 8.35646 30.3984ZM7.86563 19.3417L3.61604 23.5913C3.49979 23.7076 3.51271 23.8367 3.53854 23.9142C3.55146 23.9788 3.61604 24.108 3.77104 24.1338L5.90229 24.6376C6.74188 24.8313 7.38771 25.4771 7.58146 26.3167L8.03354 28.2155C8.07229 28.3834 8.20146 28.4351 8.27896 28.4609C8.35646 28.4738 8.48563 28.4867 8.60188 28.3576L13.549 22.6613C11.3531 22.2351 9.33813 21.0596 7.86563 19.3417ZM17.4498 22.6484L22.3969 28.3317C22.5131 28.4738 22.6552 28.4738 22.7327 28.448C22.8102 28.435 22.9265 28.3705 22.9781 28.2026L23.4302 26.3038C23.624 25.4642 24.2698 24.8184 25.1094 24.6246L27.2406 24.1209C27.3956 24.0822 27.4602 23.9659 27.4731 23.9013C27.499 23.8367 27.5119 23.6946 27.3956 23.5784L23.146 19.3288C21.6606 21.0467 19.6585 22.2221 17.4498 22.6484Z"
              fill="#eb6fa7"
            />
            <path
              d="M17.9414 17.8693C17.6056 17.8693 17.2051 17.7788 16.7272 17.4947L15.5001 16.7584L14.2731 17.4818C13.1493 18.1534 12.4131 17.7659 12.1418 17.5722C11.8706 17.3784 11.2893 16.7972 11.5864 15.5184L11.8964 14.188L10.8631 13.2322C10.2947 12.6638 10.0881 11.9793 10.2818 11.3593C10.4756 10.7393 11.0439 10.3001 11.8447 10.1709L13.2268 9.93843L13.8856 8.49177C14.2601 7.75552 14.8414 7.34216 15.5001 7.34216C16.1589 7.34216 16.7531 7.76844 17.1147 8.50469L17.8768 10.0289L19.1556 10.1838C19.9435 10.313 20.5118 10.7522 20.7185 11.3722C20.9122 11.9922 20.7056 12.6768 20.1372 13.2451L19.0651 14.3172L19.401 15.5184C19.6981 16.7972 19.1168 17.3784 18.8456 17.5722C18.7035 17.6884 18.3935 17.8693 17.9414 17.8693ZM12.4131 12.0568L13.3043 12.948C13.7176 13.3613 13.9243 14.0588 13.7951 14.6272L13.5497 15.6605L14.5831 15.0534C15.1385 14.7305 15.8876 14.7305 16.4301 15.0534L17.4635 15.6605L17.231 14.6272C17.1018 14.0459 17.2956 13.3613 17.7089 12.948L18.6001 12.0568L17.4764 11.863C16.9339 11.7726 16.3914 11.3722 16.146 10.8814L15.5001 9.61551L14.8543 10.9072C14.6218 11.3851 14.0793 11.7984 13.5368 11.8889L12.4131 12.0568Z"
              fill="#eb6fa7"
            />
          </svg>
        </span> -->
        <div class="d-flex justify-content-center w-100">
          <h5 class="font-bold  mb-0">
            <span class="font-bold fontsize-20 weight-bold"> نتیجه </span>
            <span class="fontsize16"> استفاده از محصولات ما </span>
          </h5>
          <!-- <p class="mb-0 fontsize14 line-height2 text-color-666 text-justify">
            قبل و بعد مشتریان عزیزمان بعد از استفاده محصولات و مشاوره گرفتن از
            بندیتو و متخصصان ما
          </p> -->
        </div>
      </div>
    </div>
    <div class="position-relative" v-if="beforeAfter.length">
      <div class="swiper-container before-after-container  pt-5">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in beforeAfter"
            :key="index"
            class="d-flex align-items-center justify-content-start flex-column gap-10 gap-lg-15 p-3 h-auto swiper-slide"
          >
            <div class="user-info">
                <div class="user-info-bg positionn-relative d-flex flex-column justify-content-center align-items-center pt-1 gap-4 mb-2">
                  <div class="img-holder position-absolute">
                    <img
                      v-if="
                        item.customer_image.uuid &&
                        item.customer_image.file_name
                      "
                      class="w-100 h-100"
                      loading="lazy"
                      :src="`https://api.benedito.ir/storage/${item.customer_image.uuid}/${item.customer_image.file_name}`"
                      :alt="item.customer_name"
                    />
                    <Skeleton v-else class=" " style="height: 60px;" bgColor="linear-gradient(110deg, #ededed 8%, #e5e2e2 18%, #e5e4e4 33%)"></Skeleton>
                  </div>
                    <h5 class="text-color-grey font-w-700 m-0 p-1 fontsize17">
                      {{ item.customer_name }}
                    </h5>
                    <p class="d-flex align-items-center w-s-nowrap m-0">
                      <span class="text-color-grey font-w-800 fontsize-mini"
                        >محصول خریداری شده:
                      </span>
                      <span
                        class="text-color-999 font-w-800 fontsize-mini mr-1"
                        >{{ item.product.title }}</span
                      >
                    </p>
                </div>
            </div>
            <div class="d-flex align-items-center main-content">
              <div
                class="position-relative"
                style="border-left: 2px solid white"
              >
                <img
                  loading="lazy"
                  v-if="item.after_image.uuid && item.after_image.file_name"
                  class="w-100 h-100"
                  :src="`https://api.benedito.ir/storage/${item.after_image.uuid}/${item.after_image.file_name}`"
                  alt=""
                />
                <Skeleton v-else class="skeleton-image"  bgColor="linear-gradient(110deg, #ededed 8%, #e5e2e2 18%, #e5e4e4 33%)"></Skeleton>

                <p
                  class="m-0 py-1 text-white font-w-800 fontsize-small text-center w-s-nowrap"
                >
                  {{ item.title_after }}
                </p>
              </div>
              <div
                class="position-relative"
                style="border-right: 2px solid white"
              >
                <img
                  loading="lazy"
                  v-if="item.before_image.uuid && item.before_image.file_name"
                  class="w-100 h-100"
                  :src="`https://api.benedito.ir/storage/${item.before_image.uuid}/${item.before_image.file_name}`"
                  alt=""
                />
                <Skeleton v-else class="skeleton-image" bgColor="linear-gradient(110deg, #ededed 8%, #e5e2e2 18%, #e5e4e4 33%)"></Skeleton>

                <p
                  class="m-0 py-1 text-white font-w-800 fontsize-small text-center w-s-nowrap"
                >
                  {{ item.title_before }}
                </p>
              </div>
            </div>
            <div class="description-container">
                  <p
                    class="text-color-999 font-w-100 fontsize-mini"
                    style="line-height: 2">
                    {{ item.full_description }}
                  </p>
            </div>
          </div>

        </div>
      </div>
      <div class="next-btn-holder d-none d-xl-block">
        <div class="next-btn">
          <svg
            width="46"
            height="140"
            viewBox="0 0 46 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0422 123.949C17.2381 106.695 45.9541 94.9242 45.9541 74.1977C45.7061 56.9482 15.3937 45.0078 14.8107 25.0483C7.94466 -47.1794 0.308108 58.5874 0.308109 74.8619C0.30811 91.1365 12.6215 173.304 16.0422 123.949Z"
              fill="#f4f4f4"
            />
          </svg>

          <div class="next-btn-icon"><RightChevIcon /></div>
        </div>
      </div>
      <div class="prev-btn-holder d-none d-xl-block">
        <div class="prev-btn">
          <svg
            width="46"
            height="140"
            viewBox="0 0 46 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0422 123.949C17.2381 106.695 45.9541 94.9242 45.9541 74.1977C45.7061 56.9482 15.3937 45.0078 14.8107 25.0483C7.94466 -47.1794 0.308108 58.5874 0.308109 74.8619C0.30811 91.1365 12.6215 173.304 16.0422 123.949Z"
              fill="#f4f4f4"
            />
          </svg>
          <div class="prev-btn-icon"><RightChevIcon /></div>
        </div>
      </div>
    </div>
  </section>
  <section v-else id="homeBeforeAfter" class="container my-5">
    <div>
      <div class="d-flex align-items-center gap-15">
        <span>
          <svg
            width="39"
            height="33"
            viewBox="0 0 39 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.6086 5.74549C33.5044 8.01302 38.1358 10.5073 38.8874 13.875C39.6391 17.2343 36.5031 21.4586 33.561 24.9103C30.619 28.362 27.8709 31.0326 24.6621 32.1328C21.4533 33.2329 17.7838 32.7626 14.5507 31.3937C11.3177 30.0164 8.52113 27.7489 6.18526 24.6667C3.84939 21.5762 1.97423 17.671 2.04697 13.5727C2.11163 9.47431 4.11611 5.18281 7.32491 2.78931C10.5337 0.395808 14.9549 -0.0996878 18.7456 0.672951C22.5364 1.44559 25.7047 3.47796 29.6086 5.74549Z"
              fill="#EEEEEE"
            />
            <path
              d="M15.4997 22.8552C14.983 22.8552 14.4663 22.8164 13.9755 22.726C11.2372 22.3256 8.74426 20.7498 7.16842 18.4118C6.07051 16.7585 5.48926 14.8339 5.48926 12.8448C5.48926 7.32935 9.98426 2.83435 15.4997 2.83435C21.0151 2.83435 25.5101 7.32935 25.5101 12.8448C25.5101 14.8339 24.9288 16.7585 23.8309 18.4118C22.2422 20.7627 19.7493 22.3256 16.9851 22.7389C16.533 22.8164 16.0163 22.8552 15.4997 22.8552ZM15.4997 4.77185C11.0434 4.77185 7.42676 8.38852 7.42676 12.8448C7.42676 14.4594 7.89176 16.0094 8.77009 17.3269C10.0488 19.2127 12.0509 20.4785 14.2726 20.8014C15.0993 20.9435 15.913 20.9435 16.6751 20.8014C18.9355 20.4785 20.9376 19.1998 22.2163 17.3139C23.0947 15.9964 23.5597 14.4464 23.5597 12.8318C23.5726 8.3885 19.9559 4.77185 15.4997 4.77185Z"
              fill="#eb6fa7"
            />
            <path
              d="M8.35646 30.3984C8.17563 30.3984 8.00771 30.3726 7.82688 30.3338C6.98729 30.1401 6.34146 29.4942 6.14771 28.6546L5.69563 26.7559C5.66979 26.6396 5.57938 26.5492 5.45021 26.5105L3.31896 26.0067C2.51813 25.813 1.88521 25.2188 1.66563 24.4309C1.44604 23.643 1.66563 22.7905 2.24688 22.2092L7.28438 17.1717C7.49104 16.9651 7.77521 16.8617 8.05938 16.8876C8.34354 16.9134 8.60188 17.0684 8.76979 17.3138C10.0485 19.1996 12.0506 20.4784 14.2852 20.8013C15.1119 20.9434 15.9256 20.9434 16.6877 20.8013C18.9481 20.4784 20.9502 19.1996 22.229 17.3138C22.384 17.0684 22.6552 16.9134 22.9394 16.8876C23.2235 16.8617 23.5077 16.9651 23.7144 17.1717L28.7519 22.2092C29.3331 22.7905 29.5527 23.643 29.3331 24.4309C29.1135 25.2188 28.4677 25.8259 27.6798 26.0067L25.5485 26.5105C25.4323 26.5363 25.3419 26.6267 25.3031 26.7559L24.851 28.6546C24.6573 29.4942 24.0115 30.1401 23.1719 30.3338C22.3323 30.5405 21.4669 30.2434 20.9244 29.5846L15.4994 23.3459L10.0744 29.5976C9.63521 30.1142 9.01521 30.3984 8.35646 30.3984ZM7.86563 19.3417L3.61604 23.5913C3.49979 23.7076 3.51271 23.8367 3.53854 23.9142C3.55146 23.9788 3.61604 24.108 3.77104 24.1338L5.90229 24.6376C6.74188 24.8313 7.38771 25.4771 7.58146 26.3167L8.03354 28.2155C8.07229 28.3834 8.20146 28.4351 8.27896 28.4609C8.35646 28.4738 8.48563 28.4867 8.60188 28.3576L13.549 22.6613C11.3531 22.2351 9.33813 21.0596 7.86563 19.3417ZM17.4498 22.6484L22.3969 28.3317C22.5131 28.4738 22.6552 28.4738 22.7327 28.448C22.8102 28.435 22.9265 28.3705 22.9781 28.2026L23.4302 26.3038C23.624 25.4642 24.2698 24.8184 25.1094 24.6246L27.2406 24.1209C27.3956 24.0822 27.4602 23.9659 27.4731 23.9013C27.499 23.8367 27.5119 23.6946 27.3956 23.5784L23.146 19.3288C21.6606 21.0467 19.6585 22.2221 17.4498 22.6484Z"
              fill="#eb6fa7"
            />
            <path
              d="M17.9414 17.8693C17.6056 17.8693 17.2051 17.7788 16.7272 17.4947L15.5001 16.7584L14.2731 17.4818C13.1493 18.1534 12.4131 17.7659 12.1418 17.5722C11.8706 17.3784 11.2893 16.7972 11.5864 15.5184L11.8964 14.188L10.8631 13.2322C10.2947 12.6638 10.0881 11.9793 10.2818 11.3593C10.4756 10.7393 11.0439 10.3001 11.8447 10.1709L13.2268 9.93843L13.8856 8.49177C14.2601 7.75552 14.8414 7.34216 15.5001 7.34216C16.1589 7.34216 16.7531 7.76844 17.1147 8.50469L17.8768 10.0289L19.1556 10.1838C19.9435 10.313 20.5118 10.7522 20.7185 11.3722C20.9122 11.9922 20.7056 12.6768 20.1372 13.2451L19.0651 14.3172L19.401 15.5184C19.6981 16.7972 19.1168 17.3784 18.8456 17.5722C18.7035 17.6884 18.3935 17.8693 17.9414 17.8693ZM12.4131 12.0568L13.3043 12.948C13.7176 13.3613 13.9243 14.0588 13.7951 14.6272L13.5497 15.6605L14.5831 15.0534C15.1385 14.7305 15.8876 14.7305 16.4301 15.0534L17.4635 15.6605L17.231 14.6272C17.1018 14.0459 17.2956 13.3613 17.7089 12.948L18.6001 12.0568L17.4764 11.863C16.9339 11.7726 16.3914 11.3722 16.146 10.8814L15.5001 9.61551L14.8543 10.9072C14.6218 11.3851 14.0793 11.7984 13.5368 11.8889L12.4131 12.0568Z"
              fill="#eb6fa7"
            />
          </svg>
        </span>
        <div>
          <h5 class="font-bold mb-0">
            <span class="font-bold fontsize-20 weight-bold"> نتیجه </span>
            <span class="fontsize16"> استفاده از محصولات ما </span>
          </h5>
          <p class="mb-0 fontsize14 line-height2 text-color-666 text-justify">
            قبل و بعد مشتریان عزیزمان بعد از استفاده محصولات و مشاوره گرفتن از
            بندیتو و متخصصان ما
          </p>
        </div>
      </div>
    </div>
    <div class="position-relative">
      <div class="swiper-container before-after-container mt-4">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in 4"
            :key="index"
            class="d-flex align-items-center flex-column flex-lg-row gap-15 p-3 swiper-slide"
          >
            <Skeleton style="height: 500px"></Skeleton>
          </div>
        </div>
      </div>
      <div class="next-btn-holder d-none d-xl-block">
        <div class="next-btn">
          <svg
            width="46"
            height="140"
            viewBox="0 0 46 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0422 123.949C17.2381 106.695 45.9541 94.9242 45.9541 74.1977C45.7061 56.9482 15.3937 45.0078 14.8107 25.0483C7.94466 -47.1794 0.308108 58.5874 0.308109 74.8619C0.30811 91.1365 12.6215 173.304 16.0422 123.949Z"
              fill="#f4f4f4"
            />
          </svg>

          <div class="next-btn-icon"><RightChevIcon /></div>
        </div>
      </div>
      <div class="prev-btn-holder d-none d-xl-block">
        <div class="prev-btn">
          <svg
            width="46"
            height="140"
            viewBox="0 0 46 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0422 123.949C17.2381 106.695 45.9541 94.9242 45.9541 74.1977C45.7061 56.9482 15.3937 45.0078 14.8107 25.0483C7.94466 -47.1794 0.308108 58.5874 0.308109 74.8619C0.30811 91.1365 12.6215 173.304 16.0422 123.949Z"
              fill="#f4f4f4"
            />
          </svg>
          <div class="prev-btn-icon"><RightChevIcon /></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";
import LeftChevIcon from "@/parts/Front/components/Icon/LeftChevIcon.vue";
import RightChevIcon from "@/parts/Front/components/Icon/RightChevIcon.vue";

export default {
  name: "homeBeforeAfter",
  components: {
    LeftChevIcon,
    RightChevIcon,
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("front/getBeforeAfterFromServer");
    this.initBeforeAfterSwiper();
  },
  computed: {
    beforeAfter() {
      if (this.$store.getters["front/getBeforeAfter"]) {
        return this.$store.getters["front/getBeforeAfter"];
      } else {
        return [];
      }
    },
  },
  watch: {
    beforeAfter(newValue) {
      if (newValue) {
        this.initBeforeAfterSwiper(true);
      }
    },
  },
  methods: {
    initBeforeAfterSwiper(kill = false) {
      this.initSwiper("beforeAfter", kill, () => {
        let swiper = new Swiper("#homeBeforeAfter .swiper-container", {
          spaceBetween: 10,
          slidePerView: 1,
          loop: false,
          autoplay: false,
          speed: 500,
          //   centeredSlides: true,
          //   centeredSlidesBounds: true,
          breakpoints: {
             300: {
               slidesPerView: 1.5,
               spaceBetween: 15,
             },
             520: {
               slidesPerView: 2.1,
               spaceBetween: 10,
             },
              750: {
               slidesPerView: 2.4,
               spaceBetween: 10,
             },
             992: {
               slidesPerView: 3.1,
               spaceBetween: 10,
             },
             1200: {
               slidesPerView: 3.5,
               spaceBetween: 10,
             },
           },
          navigation: {
            nextEl: "#homeBeforeAfter .next-btn-holder",
            prevEl: "#homeBeforeAfter .prev-btn-holder",
          },
        });
      });
    },
  },
};
</script>
<style scoped>
#homeBeforeAfter{
  background-color:var(--color-main);
  border-radius:50px;
}
.before-after-container .swiper-slide{
  background-color:white;
  border-radius:50px;

}
h5 span{
  color:white;
}
@media (max-width:600px){
   #homeBeforeAfter{
    border-radius:unset;
  }
}
.skeleton-image{
  width: 100%;

  height: 500px;
}
.main-content {
  width: 100%;
}
.main-content > div{
  width: 50%;
}

#homeBeforeAfter .user-info .img-holder {
  border-radius: 50%;
  background-color:rgba(238, 238, 238, 1);
  width: 50px;
  overflow: hidden;
  top:-30px;
  left:50%;
  transform:translateX(-50%);
}
#homeBeforeAfter .description-container {
  padding: 10px;
  border-radius:23px;
  background-color: #ffffff;
  border: 2px solid #e9e9e9;
}
#homeBeforeAfter .description-container p{
 display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: auto;
  line-height: 1.6;
}
/*#homeBeforeAfter .user-info-bg {
  padding: 20px 15px;
  border-radius: 35px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 50%,
    rgba(238, 238, 238, 1) 100%
  );
}*/
#homeBeforeAfter .main-content {
  border-radius: 70px;
  overflow: hidden;
}
#homeBeforeAfter .main-content p {
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
}
#homeBeforeAfter .prev-btn-holder {
  position: absolute;
  top: 50%;
  right: 98.89%;
  transform: translateY(-50%) rotateY(180deg);
  /* transform: translateX(1px); */
}
#homeBeforeAfter .next-btn-holder {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 99%;
}
#homeBeforeAfter .prev-btn {
  position: relative;
}
#homeBeforeAfter .prev-btn-icon {
  position: absolute;
  top: 53%;
  right: 8%;
  transform: translateY(-50%);
}
#homeBeforeAfter .next-btn {
  position: relative;
}
#homeBeforeAfter .next-btn-icon {
  position: absolute;
  top: 53%;
  left: 8%;
  transform: translateY(-50%);
}

@media screen and (max-width: 991px) {
  #homeBeforeAfter .main-content {
    border-radius: 20px;
    overflow: hidden;
  }
}

@media screen and (max-width: 768px) {
  .skeleton-image{
    width: 100%;
    height: 237px;
  }
 
  .before-after-container .swiper-slide{
    border-radius:23px;
  }
}
</style>
<style>
#homeBeforeAfter .next-btn-icon svg path, #homeBeforeAfter .prev-btn-icon svg path{
  fill:var(--color-main) !important;

}
</style>
